import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { hasConsentBeenGiven, setConsent } from "@/lib/consent";

export function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!hasConsentBeenGiven()) {
      setVisible(true);
    }
  }, []);
  const [showDetails, setShowDetails] = useState(false);
  const [analytics, setAnalytics] = useState(false);
  const [marketing, setMarketing] = useState(false);

  if (!visible) return null;

  // No reload needed — setConsent() calls gtag('consent','update',...)
  // which transitions GA4 from denied→granted mid-session. Reloading
  // disrupts the session, can lose gclid from the URL bar if the user
  // navigated within the SPA, and causes a duplicate session_start.
  const handleAcceptAll = () => {
    setConsent({ analytics: true, marketing: true });
    setVisible(false);
  };

  const handleRejectAll = () => {
    setConsent({ analytics: false, marketing: false });
    setVisible(false);
  };

  const handleSavePreferences = () => {
    setConsent({ analytics, marketing });
    setVisible(false);
  };

  return (
    <div className="cookie-consent">
      <div className="max-w-3xl mx-auto">
        <div className="flex flex-col gap-4">
          <div>
            <h3 className="text-base font-semibold mb-1">Cookie Preferences</h3>
            <p className="text-sm text-text-quiet m-0">
              We use cookies to analyze site usage and improve your experience.
              You can customize your preferences below.{" "}
              <Link to="/docs/legal/cookies" className="text-brand-500 underline">
                Learn more about our cookie policy
              </Link>
            </p>
          </div>

          {showDetails && (
            <div className="flex flex-col gap-3 p-4 bg-surface-sunken rounded-lg">
              <label className="flex items-center gap-3 text-sm cursor-not-allowed opacity-70">
                <input type="checkbox" checked disabled className="accent-brand-500" />
                <div>
                  <span className="font-medium">Necessary</span>
                  <span className="text-text-quiet ml-1">(always active)</span>
                </div>
              </label>
              <label className="flex items-center gap-3 text-sm cursor-pointer">
                <input
                  type="checkbox"
                  checked={analytics}
                  onChange={(e) => setAnalytics(e.target.checked)}
                  className="accent-brand-500"
                />
                <div>
                  <span className="font-medium">Analytics</span>
                  <span className="text-text-quiet ml-1">
                    — helps us understand how the site is used
                  </span>
                </div>
              </label>
              <label className="flex items-center gap-3 text-sm cursor-pointer">
                <input
                  type="checkbox"
                  checked={marketing}
                  onChange={(e) => setMarketing(e.target.checked)}
                  className="accent-brand-500"
                />
                <div>
                  <span className="font-medium">Marketing</span>
                  <span className="text-text-quiet ml-1">
                    — personalized content and ads
                  </span>
                </div>
              </label>
            </div>
          )}

          <div className="flex flex-wrap items-center gap-3">
            <button onClick={handleAcceptAll} className="btn btn-brand btn-sm">
              Accept All
            </button>
            <button onClick={handleRejectAll} className="btn btn-neutral btn-sm">
              Reject All
            </button>
            {showDetails ? (
              <button onClick={handleSavePreferences} className="btn btn-neutral btn-sm">
                Save Preferences
              </button>
            ) : (
              <button
                onClick={() => setShowDetails(true)}
                className="btn btn-neutral-plain btn-sm"
              >
                Customize
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CookieConsent;
